// extracted by mini-css-extract-plugin
module.exports = {"title":"NewsCard_title__2trzh","image":"NewsCard_image__DLFHf","text":"NewsCard_text__31EX7"};